import { PageType } from "@product/scmp-sdk";

export const pathname = "/plus/archive";

export const page = {
  route(query: QueryParameters<{ nodeId?: string }>) {
    return { pathname, query: { ...query, pageType: PageType.Plus } };
  },
};
